<template>
    <v-dialog v-model="modal" :transition="fullscreen?'dialog-bottom-transition':'dialog-transition'" persistent :fullscreen="fullscreen" 
    
    :width="$vuetify.breakpoint.xs ? '100vw': width" scrollable>
        <v-card class="fondo-curso-modal">
            <v-toolbar class="cerrar" :height="heightCerrar">
                <h2 class="ml-2">{{titulo}}</h2>
                <v-spacer> </v-spacer>
                <button v-if="mostrarCerrar" @click="$emit('click', false), $emit('pausarAudio')" class="hvr hvr-scale">
                    <v-icon color="#FFFFFF">close</v-icon>
                </button>
            </v-toolbar>
            <v-card-text class="pa-2 ma-0">
                <v-flex contain class="dialog-content" text-xs-center>
                    <slot name="modalcontent"></slot>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        model: {
            prop: 'modal',
            event: 'click'
        },
        props: {
            modal: Boolean,
            width: {
                type: String,
                default: '80vw'
            },
            fullscreen: {
                type: Boolean,
                default: true,
            },
            mostrarCerrar: {
                type: Boolean,
                default: true
            },
            heightCerrar:{
                type: String,
                default: '45px'
            },
            titulo:{
                type: String,
                default: ''
            }
        },
        data() {
            return {
            }
        },
        watch: {
            fullscreen: function(value){
                if(value){

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../scss/helpers/variables';
    
     .cerrar {
        padding-bottom: 0;
        text-align: center;
        background: #0B542D!important;
        box-shadow: none;
        flex: none;
        font-size: 1em!important;
        img{
            width: 30px;
        }
        h2{
            color: #FFFFFF;
        }

    }

    .dialog-content {
        width: 100%;
        margin: 0 auto;
        font-size: 1rem;
        padding: 0px;
        align-items: center;
        @media (max-height: 800px){
            align-items: start;
        }
    }

    .fullscreen {
        @media (min-height: 800px){
            height: 70vh;
        }
    }
    .fondo-curso-modal {
        background: #FFFFFF;
        border-radius: 7px;
    }
</style>
